<template>
    <div class="timelineContent">
        <Heading
            :h="3"
            size="m">
            {{ siteContent.order }}
        </Heading>
        <RadioButton
            v-model="timeline"
            name="uploadTime"
            id="uploadTime"
            value="uploadTime"
            expected="uploadTime">
            {{ siteContent.uploadTime }}
        </RadioButton>
        <RadioButton
            v-model="timeline"
            name="historicalTime"
            id="historicalTime"
            value="historicalTime"
            expected="historicalTime">
            {{ siteContent.historicalTime }}
        </RadioButton>

        <Heading
            :h="3"
            size="m">
            {{ siteContent.chronology }}
        </Heading>
        <RadioButton
            v-model="order"
            name="desc"
            id="desc"
            value="desc"
            expected="desc">
            {{ siteContent.newerToOlder }}
        </RadioButton>
        <RadioButton
            v-model="order"
            name="asc"
            id="asc"
            value="asc"
            expected="asc">
            {{ siteContent.olderToNewer }}
        </RadioButton>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'Timeline',
        props: {
            content: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                order: '',
                timeline: ''
            }
        },
        methods: {
            ...mapActions('users',  ['toggleTimelinePreference','toggleOrderPreference']),
            ...mapActions('journal',['purgeUserEntries'])
        },
        mounted() {
            this.order    = this.preferences.order
            this.timeline = this.preferences.timeline
        },
        watch: {
            timeline(newValue) {
                this.toggleTimelinePreference(newValue)
                this.purgeUserEntries()
            },
            order(newValue) {
                this.toggleOrderPreference(newValue)
                this.purgeUserEntries()
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../scss/variables';

    .h3 {
        margin: 1.5rem 0 0.5rem 0;
    }
</style>